import { config, authHeader, handleResponse } from '../helpers'

export const userService = {
    login,
    logout,
    me,
    getProfile,
    setProfile,
    getFeedbackStatus,
    verifyEmail,
    makePayment,
    getToken,
}

function login(email, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
    }
    return fetch(`${config.baseUrl}/auth/login`, requestOptions)
        .then(response=>{
            if(response.headers.get('authorization')){
                localStorage.setItem('token',response.headers.get('authorization'))
            }
             return handleResponse(response)})
        .then(data => {

            // login successful if there's a jwt token in the response
            if (data) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //console.log("ok token is there");
                localStorage.setItem('user', JSON.stringify(data))
            }
            return data
        })
}
function me(){
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json',...authHeader() }
    }
   
    // return fetch(`${config.baseUrl}/auth/user`, requestOptions).then(handleResponse).then(user=>user)
    console.log('fecting token');

    return fetch(`${config.baseUrl}/auth/getToken`, requestOptions)
        .then(response=>{
            console.log('dsddsds');
            console.log(response)
            if(response.headers.get('authorization')){
                localStorage.setItem('token',response.headers.get('authorization'))
            }
             return handleResponse(response)})
        .then(data => {
            console.log('dsddsds');
            // login successful if there's a jwt token in the response
            if (data) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //console.log("ok token is there");
                localStorage.setItem('user', JSON.stringify(data))
            }
            return data
        })
    
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('token')
    localStorage.removeItem('user')

}

function getProfile() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }

    return fetch(`${config.baseUrl}/profile`, requestOptions).then(handleResponse).then(profile=>profile)
}

function setProfile(profile) {

    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type':'application/json', "Accept": "application/json",
            ...authHeader()},
        body:JSON.stringify(profile)
    }
    
    return fetch(`${config.baseUrl}/updateProfile`, requestOptions).then(handleResponse).then(profile=>{return profile})
}

function getFeedbackStatus(){
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`${config.baseUrl}/filled-feedback`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data
          })
}

function verifyEmail(data){
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type':'application/json', "Accept": "application/json",
            ...authHeader()},
        body:JSON.stringify(data)
    }
    return fetch(`${config.baseUrl}/submit-verify-code`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data
          })
}


function makePayment(){
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type':'application/json', "Accept": "application/json",
            ...authHeader()},
    }
    return fetch(`${config.baseUrl}/make-payment`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        })
}

function getToken(email,id){
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type':'application/json', "Accept": "application/json"},
        body: JSON.stringify({ email, id })
    }
    
    return fetch(`${config.baseUrl}/get-token`, requestOptions)
    .then(response=>{
        
        if(response.headers.get('authorization')){
            localStorage.setItem('token',response.headers.get('authorization'))
        }
         return handleResponse(response)})
    .then(data => {

        // login successful if there's a jwt token in the response
        if (data) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            //console.log("ok token is there");
            localStorage.setItem('user', JSON.stringify(data))
        }
        return data
    })
    .catch( err=>{
        console.log(err)
    })
}

